import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

export default function Loader() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        position: "absolute",
        background: "rgb(45 76 130 / 21%)",
        zIndex: 9999,
        top: "0px",
        left: "0px",
      }}
    >
      <Box maxWidth="sm">
        {true ? (
          <CircularProgress size={60} />
        ) : (
          <>
            <h1>Welcome to My App</h1>
          </>
        )}
      </Box>
    </div>
  );
}
